const GIF_FILE_EXTENSIONS = ["gif"];

export const isGif = url => {
  if (!url) return false;

  // Handle URLs with query parameters by removing them first
  const urlWithoutQuery = url.split("?")[0];
  const fileExtension = urlWithoutQuery.split(".").pop();

  const result = GIF_FILE_EXTENSIONS.some(
    extension => fileExtension && fileExtension.toLowerCase() === extension
  );

  return result;
};
